import { SelectHTMLAttributes } from "react";
import type { FieldError, UseFormRegisterReturn } from "react-hook-form";

import { FormField } from "@/components/form/FormField";

export function SelectField({
  id,
  label,
  error,
  children,
  register,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & {
  id: string;
  label: string;
  error: FieldError["message"] | null;
  children:
    | React.ReactElement<HTMLOptionElement | HTMLOptGroupElement>
    | React.ReactElement<HTMLOptionElement | HTMLOptGroupElement>[];
  register: UseFormRegisterReturn | null;
}) {
  return (
    <FormField id={id} label={label} error={error} register={register}>
      <select
        id={id}
        className="w-full rounded-md border px-3 py-2 text-gray-900"
        {...props}
      >
        {children}
      </select>
    </FormField>
  );
}
